import { useCallback } from 'react';

import * as Types from './types';
import { useGenericSend } from '../useGenericSend';

export const useGetTemporaryAuthenticationToken = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IGetTemporaryAuthenticationTokenRequestData) => {
        const { data } = await send<
            Types.IGetTemporaryAuthenticationTokenRequestData, Types.IGetTemporaryAuthenticationTokenResponseData
        >({
            ID: 30001,
            responses: [30002, 30003],
            description: 'Get Temporary Authentication Token',
            ...request,
            serviceType: request.serviceType || 'GamePlay'
        });

        return data;
    }, [send]);
};
